import router from "next/router";
import { Button } from "../ui/button";
import {
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from "../ui/credenza";
import { useTranslations } from "next-intl";
import Image from "next/image";

export default function DefaultNotificationPermissionCredenzaContent({
  setOpen,
}: any) {
  const t = useTranslations("Notifications");
  return (
    <CredenzaContent className="md:max-w-2xl gap-y-5">
      <CredenzaHeader>
        <CredenzaTitle>
          {t(
            "ask-title"
          )}
        </CredenzaTitle>
        <CredenzaDescription className="py-5">
          <Image src={'/illustrations/glass/3d-glassy-composition-with-smartphone-mockup-and-sphere.png'} height={200} width={200} alt='notifications' className="mx-auto"/>
          {t("ask-description")}
        </CredenzaDescription>
      </CredenzaHeader>
      <CredenzaFooter className="gap-3 sm:flex-col sm:justify-stretch">
        <Button
          className="w-full"
          onClick={(e) => {
            e.preventDefault();
            Notification.requestPermission().then(() => {
              setOpen(false);
              router.reload();
            });
          }}
        >
          {t("ask-button-accept")}
        </Button>

        <Button className="w-full" variant={"ghost"}>
          {t("ask-button-later")}
        </Button>
      </CredenzaFooter>
    </CredenzaContent>
  );
}

export async function getServerSideProps(context: any) {
  return {
    props: {
      messages: (await import(`@/public/i18n/${context.locale}.json`)).default,
    },
  };
}
